module.exports = __webpack_public_path__ + "static/assets/9c73ed704283d5f8b4f2840576d22154.svg";